import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
const SEGUNDOS_OFERTA = 13 * 3600 + 26 * 60 + 42;
export function Countdown() {
  const {
    horas,
    minutos,
    segundos
  } = useCountdown(SEGUNDOS_OFERTA);
  const unidades: Array<{
    valor: string;
    etiqueta: string;
  }> = [{
    valor: horas,
    etiqueta: 'hs'
  }, {
    valor: minutos,
    etiqueta: 'min'
  }, {
    valor: segundos,
    etiqueta: 'seg'
  }];
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Quedan ${horas} horas, ${minutos} minutos y ${segundos} segundos`} data-id="element-95" data-mp="3c1mi0hnvqjxn">
      {unidades.map((unidad, index) => <React.Fragment key={unidad.etiqueta} data-id="element-96" data-mp="325sw47o9te37" data-mpi={index}>
          {index > 0 && <span className="font-display text-2xl font-bold text-brand-300" aria-hidden="true" data-id="element-97" data-mp="373b866xl49ff">
              :
            </span>}
          <div className="min-w-[84px] rounded-2xl border border-edge bg-surface px-3 py-3 text-center sm:min-w-[100px]" data-id="element-98" data-mp="15b6aeetemhws">
            <div className="font-display text-3xl font-bold tabular-nums text-brand-700 sm:text-4xl" data-id="element-99" data-mp="y0endtowvxxs">
              {unidad.valor}
            </div>
            <div className="mt-1 text-[11px] font-semibold uppercase tracking-widest text-muted" data-id="element-100" data-mp="szzbz7o6x0ig">
              {unidad.etiqueta}
            </div>
          </div>
        </React.Fragment>)}
    </div>;
}